import objectUtils from '../utils/object-utils'

export default class OrderDetails {
  constructor (options = {}) {
    this.model = 'OrderDetails'

    this.id = objectUtils.get(options, 'id', null)
    this.org_id = objectUtils.get(options, 'org_id', null)
    this.denomination = objectUtils.get(options, 'denomination', null)
    this.item_data = objectUtils.get(options, 'item_data', {})
    this.total = objectUtils.get(options, 'total', -1)
    this.product_types = objectUtils.get(options, 'product_types', {})

    // Auditing
    this.created_at = objectUtils.get(options, 'created_at', null)
    this.updated_at = objectUtils.get(options, 'updated_at', null)
  }
}
